export function start_timer(interval, cb) {
  return window.setInterval(cb, interval);
}

export function stop_timer(id) {
  clearInterval(id);
}
